module.exports = __webpack_public_path__ + "static/img/player.390ac20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/worldview/player.png
// module id = 6tIN
// module chunks = 1